import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated, hasReportsAccess } from './cognitoAuth';
import { signInWithRedirect } from 'aws-amplify/auth';

interface ProtectedRouteProps {
  component: React.ComponentType;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component: Component }) => {
  const [authState, setAuthState] = React.useState<'loading' | 'authenticated' | 'unauthenticated'>('loading');
  const [hasAccess, setHasAccess] = React.useState<boolean | null>(null);
  const location = useLocation();

  React.useEffect(() => {
    const checkAuth = async () => {
      try {
        const auth = await isAuthenticated();
        if (auth) {
          const access = await hasReportsAccess();
          setHasAccess(access);
          setAuthState('authenticated');
        } else {
          setAuthState('unauthenticated');
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        setAuthState('unauthenticated');
      }
    };
    checkAuth();
  }, []);

  if (authState === 'loading') {
    return null; // or a loading spinner
  }

  if (authState === 'unauthenticated') {
    // Redirect to Cognito hosted UI using signInWithRedirect
    signInWithRedirect({
      customState: location.pathname
    });
    return null;
  }

  if (!hasAccess) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  return <Component />;
}; 